<!-- <div class="row">
  <div class="col-10">
<nav class="navbar navbar-expand-lg ">
  <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG"alt="logo2">
</nav>
</div>
<div class="col-2 mainlogout">
  <a class="logout" routerLink = "/logout" routerLinkActive = "active">Logout</a>

</div>
</div>  -->
<app-header></app-header>

<br />
<div class="container-fluid bg-light px-lg-5">
  <nav class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/registration">App Registration <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/app-mgmt">App Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/profile-mgmt">Profile Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>

      </ul>
    </div>
  </nav>
</div>
<br>
<br>
<div *ngIf="isEditComplete" class="row justify-content-center">



  <div class="col-md-8">
    <div class="card">
      <div class="card-header">
        <p><b>Details has been Edited Succesfully.</b></p>
      </div>
      <div class="card-body">
        <div>
          <p><b>Application Name :</b> {{editItemdata.displayName}}</p>
          <p> <b>Application Purpose : </b>{{editItemdata.application_Purpose}}</p>
          <p><b>Logo:</b></p><span>
            <div class="z-depth-1-half mb-4">
              <img *ngIf="imagebase64edit;else base64imgbind" class=" logo" [src]="url" alt="" />
              <ng-template #base64imgbind>
                <div class="z-depth-1-half mb-4">
                  <img class=" logo" [src]="base64imgForHtmlBind" alt="" />
                  <!-- <img class="logo"
                 [src]="base64ImageUrl" 
                 alt=""/> -->
                </div>

              </ng-template>
            </div>
            <br>
          </span>
          <p><b>Redirect URI :</b> {{this.editItemdata.urls}}</p>
          <p><b>ClientId :</b>{{editItemdata.clientId}}</p>
          <p><b>ClientSecret:Please use the earlier generated client secret or generate new one.</b></p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="editWaitError" class="editwait">{{this.testMessage}}</div>
<div *ngIf="editWait" class="editwait">Please wait for Editing..</div>

<br>

<p *ngIf="isEditForm" class="mandatorynote"> Fields with * symbol are mandatory one.</p>

<div *ngIf="isEditForm" class="container">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card" *ngIf="editItemdata">
        <div class="card-header">Edit Details</div>
        <div class="card-body">
          <form class="form-horizontal" name="form" (ngSubmit)="f.valid " #f="ngForm" novalidate>

            <!-- <button type="submit" class="btn btn-primary">
              <i class="fa fa-user-circle"></i> Delete
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="fa fa-user-circle"></i> Recreate secret
            </button> -->
            <!-- <div class="row" *ngFor="let data of editItemdata"> -->
            <!-- <div class="form-check">
                
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="application_Type"  value='Production'
                [(ngModel)]="editItemdata.application_Type" checked>
                  Production
                </label>
              </div>
              <div class="form-check">
                
                <label class="form-check-label">
                  <input  class="form-check-input" type="radio" name="application_Type"  value='NonProduction'
                 [(ngModel)]="editItemdata.application_Type" checked>
                  Non-Production
                </label>
              </div> -->
            <br>




            <div class="form-group">
              <label for="appName" class="cols-sm-2 control-label required">Name of Application</label>
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input [(ngModel)]="editItemdata.displayName" #app_name="ngModel" type="text" class="form-control"
                    placeholder="" name="name" required />



                </div>
              </div>
              <br>
              <div *ngIf="app_name.invalid && f.submitted ">
                <p [ngStyle]="{backgroundColor:'red', color:'white'}">Application Name is required.</p>
              </div>
            </div>

            <div class="form-group">
              <label for="appNamePurpose" class="cols-sm-2 control-label required">Application Purpose</label>
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input [(ngModel)]="editItemdata.application_Purpose" #app_purpose="ngModel" type="text"
                    class="form-control" name="application_Purpose" placeholder="" required />
                </div>

              </div>
            </div>
            <div class="form-group">
              <label for="url" class="cols-sm-2 control-label required">Redirect Url</label>
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input [(ngModel)]="this.editItemdata.urls" #uri="ngModel" type="text" class="form-control"
                    id="redirectUris" placeholder="" name="redirectUris"
                    pattern="^(https?|chrome):\/\/[^\s$.?#].[^\s]*$" #uris=ngModel required />
                </div>
                <p *ngIf="!uris.valid" class="msgred">Redirect Url must in format https://fqdn/resource</p>
              </div>
              <br>
              <!-- <div *ngIf="redirectUris.invalid && f.submitted "><p [ngStyle] = "{backgroundColor:'red', color:'white'}">Redirect URI is required.</p></div> -->
            </div>

            <div class="form-group">
              <label for="url" class="cols-sm-2 control-label required">Client Id</label>
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"></span>
                  <input [(ngModel)]="editItemdata.clientId" type="text" class="form-control" id="clientId"
                    name="clientId" placeholder="aght45-ytyt68-dfdf89-tyty89" readonly />
                </div>
              </div>
            </div>

            <div class="file-field">
              <div *ngIf="imgBase64blnk" class="z-depth-1-half mb-4">
                <img class=" logo" [src]="url" alt="" />
                <!-- <img class="logo"
                 [src]="base64ImageUrl" 
                 alt=""/> -->
              </div>
              <div class="z-depth-1-half mb-4">
                <img *ngIf="imagebase64edit;else base64imgbind" class=" logo" [src]="url" alt="" />
                <ng-template #base64imgbind>
                  <div class="z-depth-1-half mb-4">
                    <img class=" logo" [src]="base64imgForHtmlBind" alt="" />
                    <!-- <img class="logo"
                     [src]="base64ImageUrl" 
                     alt=""/> -->
                  </div>
                </ng-template>
                <!-- <img class="logo"
                 [src]="base64ImageUrl" 
                 alt=""/> -->
              </div>


              <!-- <div class="d-flex justify-content-center"> -->
              <div class="btn btn-mdb-color btn-rounded float-left leftpadding">
                <span>Choose Logo</span>
                <input type="file" (change)="onFileSelect($event)" accept="image/png,image/jpg" />
              </div>
              <p class="msgred">Image should be type of image only like .jpg/png</p>
              <!-- </div> -->
            </div>
            <br>
            <br>

            <!-- <div class="form-group">
              <label for="appName" class="cols-sm-2 control-label required"
                >Privacy Policy</label
              >
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ></span>
                  <input
                    type="text"
                    class="form-control"
                     name = "Privacy Policy"
                    placeholder="Enter Privacy Policy Url"
                    ngModel
                    required
                  />
                </div>
              </div>
            </div>


             -->

            <!-- <div class="form-group"> -->
            <!-- <label for="username" class="cols-sm-2 control-label">Terms and Conditions</label> -->
            <!-- <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ></span>
                  <textarea
                    readonly
                    class="form-control textarea"
                    id="policy"
                    placeholder="There will be Privacy Policies.There will be Privacy Policies.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:
                          
                                            If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.
                                            
                                            example using twig for php framework symfony :"
                  ></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input [(ngModel)]="checkedPolicy" #policy_check="ngModel"
                  (change) = "checkboxPolicyClicked(checkedPolicy)"
                    class="form-check-input"
                    type="checkbox"
                    id="gridCheck"
                    name= "policy"
                    required
                  />
                  <label class="form-check-label required" for="gridCheck">
                    Privacy Policy
                  </label>
                  <div  *ngIf="policy_check.invalid && f.submitted "><p [ngStyle] = "{backgroundColor:'red', color:'white'}">Policy should be checked.</p></div>
                </div>
              </div>
            </div>

            <div class="form-group"> -->
            <!-- <label for="username" class="cols-sm-2 control-label">Terms and Conditions</label> -->
            <!-- <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ></span>
                  <textarea
                    readonly
                    class="form-control textarea"
                    id="terms"
                    placeholder="There will be Terms and Conditions.There will be Terms and Conditions.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:
                          
                                            If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.
                                            
                                            example using twig for php framework symfony :"
                  ></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input [(ngModel)]="checkedTerms" #terms_check="ngModel"
                  (change) = "checkboxTermsClicked(checkedTerms)"
                    class="form-check-input"
                    type="checkbox"
                    id="gridCheck"
                    name="terms"
                    required
                  />
                  <label class="form-check-label required" for="gridCheck">
                    Terms and Conditions
                  </label>
                  <div  *ngIf="terms_check.invalid && f.submitted "><p [ngStyle] = "{backgroundColor:'red', color:'white'}">Terms and Conditions should be checked.</p></div>
                </div>
              </div>
            </div>

            <div class="form-group"> -->
            <!-- <label for="username" class="cols-sm-2 control-label">Code of Conduct</label> -->
            <!-- <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"
                    ></span>
                  <textarea
                    readonly
                    class="form-control textarea"
                    id="code-of-conduct"
                    placeholder="There will be code-of-conduct.There will be code-of-conduct.I know this post has been (very well) answered by Aquarelle but just in case somebody is having this issue with other tag forms with no text such as inputs i'll leave this here:
                          
                                            If you have an input in your form and placeholder is not showing because a white space at the beginning, this may be caused for you value attribute. In case you are using variables to fill the value of an input check that there are no white spaces between the commas and the variables.
                                            
                                            example using twig for php framework symfony :"
                  ></textarea>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <input [(ngModel)]="checkedCodeConduct" #cod_check="ngModel"
                  (change) = "checkboxCodeConductClicked(checkedCodeConduct)"
                    class="form-check-input"
                    type="checkbox"
                    id="gridCheck"
                    name="code-of-conduct"
                    required
                  />
                  <label class="form-check-label required" for="gridCheck">
                    Code of Conduct
                  </label>
                  <div  *ngIf="cod_check.invalid && f.submitted "><p [ngStyle] = "{backgroundColor:'red', color:'white'}">Code Of Conduct should be checked.</p></div>
                </div>
              </div>
            </div>

             -->

            <div class="form-group">
              <button type="button" class="btn btn-primary btn-lg btn-block login-button editbutton"
                (click)="callPostEditService()">
                Submit
              </button>
            </div>
            <!-- </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isEditForm">
  <app-footer></app-footer>
</div>
